import React from 'react';
import LazyAsset from 'components/LazyAsset';
import { SKIMLINKS_CODE } from 'constants/vendor';

const URL = `https://s.skimresources.com/js/${SKIMLINKS_CODE}.skimlinks.js`;

function Skimlinks() {
  return <LazyAsset type="js" uri={URL} />;
}

export default Skimlinks;
